import { render } from "./CourseUpdate.vue?vue&type=template&id=4c5070ee"
import script from "./CourseUpdate.vue?vue&type=script&lang=js"
export * from "./CourseUpdate.vue?vue&type=script&lang=js"

import exportComponent from "/builds/skilltech-ph/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__